/* Homepage Hero and Sale are server-rendered in Liquid to prevent layout shifts. */

/* Homenetics product Sale price — synced with Shopify variants and Hulk Options */
(function () {
  'use strict';

  function getDiscountPercent() {
    var links = document.querySelectorAll('a[href*="/sale-"]');
    var found = 0;
    for (var i = 0; i < links.length; i++) {
      var href = (links[i].getAttribute('href') || '').toLowerCase();
      var match = href.match(/(?:^|\/|-)sale-(10|15|20|30|35|50)(?:\/|\?|#|$)/);
      if (match) found = Math.max(found, Number(match[1]));
    }
    return found;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function initProductSalePrice() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var percent = getDiscountPercent();
    if (!percent) return;

    if (!document.getElementById('hn-product-sale-price-css')) {
      var css = document.createElement('style');
      css.id = 'hn-product-sale-price-css';
      css.textContent =
        '.hn-product-sale-price{display:flex!important;align-items:baseline;gap:10px;flex-wrap:wrap}' +
        '.hn-product-sale-price .hn-sale-current{color:#d94b3d;font-weight:700;font-size:1.18em}' +
        '.hn-product-sale-price .hn-sale-original{color:#8b8b8b;font-size:.9em;text-decoration:line-through;text-decoration-thickness:1.5px}' +
        '.hn-product-sale-price .hn-sale-badge{display:inline-flex;align-items:center;background:#d94b3d;color:#fff;border-radius:999px;padding:4px 9px;font-size:11px;font-weight:700;line-height:1;letter-spacing:.02em}' +
        '.hn-product-sale-price .hn-sale-note{flex-basis:100%;color:#777;font-size:12px;line-height:1.35;margin-top:1px}' +
        '@media(max-width:767px){.hn-product-sale-price{gap:7px}.hn-product-sale-price .hn-sale-current{font-size:1.12em}.hn-product-sale-price .hn-sale-badge{padding:4px 7px;font-size:10px}}';
      document.head.appendChild(css);
    }

    var queued = false;

    function refresh() {
      queued = false;
      var price = document.querySelector(
        '.t4s-product__info-wrapper .t4s-product__price-review .t4s-product-price[data-product-price], ' +
        '.t4s-product__info-wrapper .t4s-product-price[data-product-price]'
      );
      if (!price) return;

      var original = Number(
        price.getAttribute('data-product-price') ||
        price.getAttribute('data-pr-price')
      );
      if (!Number.isFinite(original) || original <= 0) return;

      if (
        price.getAttribute('data-hn-sale-source') === String(original) &&
        price.querySelector('.hn-sale-current')
      ) return;

      var discounted = Math.round(original * (100 - percent) / 100);
      price.setAttribute('data-hn-sale-source', String(original));
      price.setAttribute('data-hn-sale-percent', String(percent));
      price.classList.add('hn-product-sale-price');
      price.innerHTML =
        '<span class="money hn-sale-current">' + formatMoney(discounted) + '</span>' +
        '<s class="money hn-sale-original">' + formatMoney(original) + '</s>' +
        '<span class="hn-sale-badge">' + percent + '% OFF</span>' +
        '<span class="hn-sale-note">Discount applied automatically at checkout</span>';
    }

    function scheduleRefresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(refresh);
    }

    var productInfo =
      document.querySelector('.t4s-product__info-wrapper') ||
      document.querySelector('[data-product-featured]') ||
      document.body;

    new MutationObserver(scheduleRefresh).observe(productInfo, {
      attributes: true,
      attributeFilter: ['data-product-price', 'data-pr-price'],
      childList: true,
      subtree: true
    });

    document.addEventListener('change', function (event) {
      if (
        event.target.closest('.t4s-product-form__variants') ||
        event.target.closest('.hulkapps_product_options')
      ) {
        scheduleRefresh();
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target.closest('.hulkapps_product_options')) {
        scheduleRefresh();
      }
    }, true);

    ['variant:changed', 'variant:change', 'product:variant-change', 'hulkapps:price-change']
      .forEach(function (eventName) {
        document.addEventListener(eventName, scheduleRefresh);
      });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSalePrice);
  } else {
    initProductSalePrice();
  }
})();

/* Homenetics cart Sale presentation â€” uses Shopify's final discounted values */
(function () {
  'use strict';

  function initCartSalePresentation() {
    if (!document.body || !document.body.classList.contains('template-cart')) return;

    if (!document.getElementById('hn-cart-sale-css')) {
      var style = document.createElement('style');
      style.id = 'hn-cart-sale-css';
      style.textContent =
        '.template-cart .hn-cart-sale-item{position:relative;background:linear-gradient(135deg,rgba(255,249,241,.72),rgba(255,255,255,0) 48%);border-color:rgba(217,75,61,.22)!important}' +
        '.template-cart .hn-cart-sale-item:before{content:"SALE";position:absolute;top:16px;left:16px;z-index:2;background:#d94b3d;color:#fff;border-radius:999px;padding:5px 10px;font-size:10px;font-weight:800;line-height:1;letter-spacing:.08em}' +
        '.template-cart .hn-cart-sale-item .t4s-cart_meta_prices:before{content:"SALE PRICE";display:block;color:#d94b3d;font-size:10px;font-weight:800;letter-spacing:.09em;margin-bottom:4px}' +
        '.template-cart .hn-cart-sale-item .t4s-cart_price,.template-cart .hn-cart-sale-item .t4s-cart-item-price{color:#d94b3d!important;font-size:18px!important;font-weight:800!important}' +
        '.template-cart .hn-cart-discount-detail{display:flex;align-items:center;justify-content:center;gap:7px;flex-wrap:wrap;margin-top:8px}' +
        '.template-cart .hn-cart-discount-percent{display:inline-flex;align-items:center;background:#d94b3d;color:#fff;border-radius:999px;padding:5px 9px;font-size:10px;font-weight:800;letter-spacing:.04em}' +
        '.template-cart .hn-cart-discount-saving{color:#d94b3d;font-size:12px;font-weight:700}' +
        '.template-cart .hn-cart-was{display:block;color:#8b8b8b;font-size:12px;text-decoration:line-through;text-decoration-thickness:1.5px;margin-bottom:3px}' +
        '.template-cart .t4s-cart-total{position:relative;border:1px solid rgba(217,75,61,.18);border-radius:14px;padding:18px!important;background:linear-gradient(145deg,#fff 48%,#fff8f3 100%)}' +
        '.template-cart .hn-cart-sale-banner{display:flex;align-items:center;gap:11px;padding:12px 13px;margin:0 0 17px;background:#fff3ec;border:1px solid rgba(217,75,61,.2);border-radius:10px;color:#193f4c}' +
        '.template-cart .hn-cart-sale-icon{display:grid;place-items:center;flex:0 0 34px;height:34px;border-radius:50%;background:#d94b3d;color:#fff;font-size:16px}' +
        '.template-cart .hn-cart-sale-banner strong{display:block;color:#d94b3d;font-size:12px;line-height:1.2;letter-spacing:.06em}' +
        '.template-cart .hn-cart-sale-banner span{display:block;color:#68777c;font-size:11px;line-height:1.35;margin-top:2px}' +
        '.template-cart .t4s-cart__originalPrice{color:#8a8a8a!important;font-size:14px!important;text-decoration:line-through;text-decoration-thickness:1.5px}' +
        '.template-cart .t4s-cart__discountPrice{display:inline-block!important;background:#d94b3d;color:#fff!important;border-radius:999px;padding:6px 10px;margin:7px 0;font-size:12px!important;font-weight:800!important}' +
        '.template-cart .t4s-cart__totalPrice{color:#173f4d!important;font-size:27px!important;font-weight:800!important;line-height:1.15}' +
        '@media(max-width:767px){.template-cart .hn-cart-sale-item:before{top:10px;left:10px}.template-cart .hn-cart-discount-detail{justify-content:flex-start}.template-cart .t4s-cart-total{padding:15px!important}.template-cart .t4s-cart__totalPrice{font-size:24px!important}}';
      document.head.appendChild(style);
    }

    var busy = false;

    function parseMoney(value) {
      var number = Number(String(value || '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(number) ? Math.abs(number) : 0;
    }

    function formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    }

    function refreshCartSale() {
      busy = false;

      document.querySelectorAll('.t4s-page_cart__item').forEach(function (item) {
        var discountItem = item.querySelector('.t4s-order-discount__item');
        if (!discountItem) return;

        var raw = (discountItem.textContent || '').replace(/\s+/g, ' ').trim();
        var match = raw.match(/sale\s+(10|15|20|30|35|50)%.*?\(-?\$?([\d,.]+)\)/i);
        if (!match) return;

        item.classList.add('hn-cart-sale-item');

        var detail = item.querySelector('.hn-cart-discount-detail');
        if (!detail) {
          detail = document.createElement('div');
          detail.className = 'hn-cart-discount-detail';
          discountItem.insertAdjacentElement('afterend', detail);
        }
        var detailMarkup =
          '<span class="hn-cart-discount-percent">' + match[1] + '% OFF</span>' +
          '<span class="hn-cart-discount-saving">You save ' + formatMoney(parseMoney(match[2])) + '</span>';
        if (detail.innerHTML !== detailMarkup) detail.innerHTML = detailMarkup;

        var lineTotal = item.querySelector('.t4s-cart-item-price');
        if (lineTotal) {
          var current = parseMoney(lineTotal.textContent);
          var saved = parseMoney(match[2]);
          var was = item.querySelector('.hn-cart-was');
          if (!was) {
            was = document.createElement('span');
            was.className = 'hn-cart-was';
            lineTotal.insertAdjacentElement('beforebegin', was);
          }
          var wasText = 'Was ' + formatMoney(current + saved);
          if (was.textContent !== wasText) was.textContent = wasText;
        }
      });

      var summary = document.querySelector('.t4s-cart-total');
      var summaryDiscount = document.querySelector('.t4s-cart__discountPrice');
      if (summary && summaryDiscount) {
        var savedAmount = parseMoney(summaryDiscount.textContent);
        var savedLabel = 'YOU SAVE ' + formatMoney(savedAmount);
        if (summaryDiscount.textContent !== savedLabel) summaryDiscount.textContent = savedLabel;

        var banner = summary.querySelector('.hn-cart-sale-banner');
        if (!banner) {
          banner = document.createElement('div');
          banner.className = 'hn-cart-sale-banner';
          banner.innerHTML =
            '<div class="hn-cart-sale-icon">%</div>' +
            '<div><strong>SALE DISCOUNT APPLIED</strong><span>Your discounted price is active and will carry through checkout.</span></div>';
          summary.insertAdjacentElement('afterbegin', banner);
        }
      }
    }

    function scheduleRefresh() {
      if (busy) return;
      busy = true;
      setTimeout(refreshCartSale, 80);
    }

    var cartRoot = document.querySelector('.t4s-main-cart') || document.body;
    new MutationObserver(scheduleRefresh).observe(cartRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', scheduleRefresh, true);
    refreshCartSale();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSalePresentation);
  } else {
    initCartSalePresentation();
  }
})();
/* Homenetics enhanced mini cart */
(function () {
  'use strict';

  function initHnMiniCart() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;

    if (!document.getElementById('hn-mini-cart-css')) {
      var css = document.createElement('style');
      css.id = 'hn-mini-cart-css';
      css.textContent =
        '#t4s-mini_cart.hn-mini-open{display:flex!important;visibility:visible!important;opacity:1!important;transform:translate3d(0,0,0)!important;z-index:100002!important;width:460px;max-width:94vw}' +
        '.hn-mini-overlay{position:fixed;inset:0;background:rgba(13,31,38,.55);backdrop-filter:blur(1px);z-index:100001;opacity:0;transition:opacity .22s ease}' +
        '.hn-mini-overlay.is-visible{opacity:1}.hn-mini-lock{overflow:hidden!important}' +
        '#t4s-mini_cart .t4s-drawer__header{border-bottom:1px solid #e8ecee;padding:17px 20px}' +
        '#t4s-mini_cart .t4s-drawer__header span{font-weight:800;letter-spacing:.03em;color:#153f4c}' +
        '#t4s-mini_cart .t4s-mini_cart__item{align-items:flex-start!important;padding:18px 16px!important;border-bottom:1px solid #edf0f1}' +
        '#t4s-mini_cart .t4s-mini_cart__img{width:92px!important;min-width:92px!important;height:118px!important;background:#f7f8f7!important;border-radius:8px}' +
        '#t4s-mini_cart .t4s-mini_cart__img img{object-fit:contain!important}' +
        '#t4s-mini_cart .t4s-mini_cart__info{min-width:0;flex:1;padding-left:14px!important}' +
        '#t4s-mini_cart .t4s-mini_cart__title{white-space:normal!important;display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-weight:700;line-height:1.35;color:#153f4c}' +
        '#t4s-mini_cart .t4s-cart_meta_variant{font-size:12px;color:#778287;margin:5px 0 8px}' +
        '#t4s-mini_cart .hn-mini-properties .t4s-product-details__item{font-size:11px;line-height:1.4;margin:2px 0;color:#69777c}' +
        '#t4s-mini_cart .hn-mini-properties:not(.is-expanded) .t4s-product-details__item:nth-child(n+4){display:none!important}' +
        '#t4s-mini_cart .hn-mini-details{border:0;background:transparent;color:#0e596c;text-decoration:underline;padding:3px 0 5px;font-size:11px;font-weight:700;cursor:pointer}' +
        '#t4s-mini_cart .hn-mini-sale-prices{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap;margin:8px 0 5px}' +
        '#t4s-mini_cart .hn-mini-current{color:#d94b3d;font-size:17px;font-weight:800}' +
        '#t4s-mini_cart .hn-mini-original{color:#92999c;font-size:12px;text-decoration:line-through;text-decoration-thickness:1.5px}' +
        '#t4s-mini_cart .hn-mini-badge{background:#d94b3d;color:#fff;border-radius:999px;padding:4px 7px;font-size:9px;font-weight:800}' +
        '#t4s-mini_cart .hn-mini-saving{flex-basis:100%;color:#d94b3d;font-size:11px;font-weight:700}' +
        '#t4s-mini_cart .hn-has-sale>.t4s-cart_price{display:none!important}' +
        '#t4s-mini_cart .hn-mini-sale-summary{margin:0 0 12px;padding:13px 14px;border:1px solid rgba(217,75,61,.2);border-radius:10px;background:#fff5ef}' +
        '#t4s-mini_cart .hn-mini-summary-row{display:flex;justify-content:space-between;align-items:center;margin:4px 0;font-size:12px;color:#68777c}' +
        '#t4s-mini_cart .hn-mini-summary-row.original span:last-child{text-decoration:line-through}' +
        '#t4s-mini_cart .hn-mini-summary-row.saving{color:#d94b3d;font-weight:800}' +
        '#t4s-mini_cart .hn-mini-summary-row.total{padding-top:7px;margin-top:7px;border-top:1px solid rgba(217,75,61,.16);color:#153f4c;font-size:17px;font-weight:800}' +
        '#t4s-mini_cart .t4s-cart-total{padding-top:10px!important}' +
        '#t4s-mini_cart .t4s-btn__cart,#t4s-mini_cart .t4s-btn__checkout{min-height:46px!important;border-radius:7px!important;font-weight:800!important}' +
        '#t4s-mini_cart .t4s-btn__checkout{background:#ff9f22!important;color:#fff!important}' +
        '#t4s-mini_cart .t4s-cat__imgtrust{display:flex!important;justify-content:center!important;align-items:center!important;gap:8px!important;flex-wrap:wrap!important;padding:12px 0!important}' +
        '#t4s-mini_cart .t4s-cat__imgtrust img:not([alt="shopify pay"]):not([alt="visa"]):not([alt="master"]):not([alt="apple pay"]){display:none!important}' +
        '#t4s-mini_cart .t4s-cat__imgtrust img{height:30px!important;width:auto!important;margin:0!important}' +
        '@media(max-width:520px){#t4s-mini_cart.hn-mini-open{width:92vw}.hn-mini-overlay{backdrop-filter:none}#t4s-mini_cart .t4s-mini_cart__item{padding:14px 12px!important}#t4s-mini_cart .t4s-mini_cart__img{width:78px!important;min-width:78px!important;height:104px!important}}';
      document.head.appendChild(css);
    }

    function money(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
    }

    function closeMini() {
      drawer.classList.remove('hn-mini-open');
      drawer.classList.add('t4s-dn');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hn-mini-lock');
      document.body.classList.remove('hn-mini-lock');
      var overlay = document.querySelector('.hn-mini-overlay');
      if (overlay) overlay.remove();
    }

    function openMini() {
      var overlay = document.querySelector('.hn-mini-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'hn-mini-overlay';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', closeMini);
      }
      drawer.classList.remove('t4s-dn');
      drawer.classList.add('hn-mini-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hn-mini-lock');
      document.body.classList.add('hn-mini-lock');
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
      scheduleRefresh();
    }

    document.addEventListener('click', function (event) {
      var headerCart = event.target.closest('.hnh-ic[aria-label="Cart"]');
      if (headerCart) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openMini();
        return;
      }
      var details = event.target.closest('.hn-mini-details');
      if (details) {
        event.preventDefault();
        var list = details.previousElementSibling;
        var expanded = list.classList.toggle('is-expanded');
        details.textContent = expanded ? 'Hide details' : details.dataset.label;
      }
      if (event.target.closest('#t4s-mini_cart .t4s-drawer__close')) closeMini();
    }, true);

    var queued = false;
    function scheduleRefresh() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; refreshMini(); }, 180);
    }

    async function refreshMini() {
      var response;
      try { response = await fetch('/cart.js', { credentials: 'same-origin' }); } catch (error) { return; }
      if (!response.ok) return;
      var cart = await response.json();

      drawer.querySelectorAll('.t4s-mini_cart__item').forEach(function (element) {
        var remove = element.querySelector('[data-cart-remove][data-id]');
        var key = remove && remove.getAttribute('data-id');
        var item = cart.items.find(function (entry) { return entry.key === key; });
        if (!item) return;

        var properties = element.querySelector('.t4s-cart_meta_propertyList');
        if (properties && properties.children.length > 3) {
          properties.classList.add('hn-mini-properties');
          var button = element.querySelector('.hn-mini-details');
          if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'hn-mini-details';
            button.dataset.label = 'View all ' + properties.children.length + ' options';
            button.textContent = button.dataset.label;
            properties.insertAdjacentElement('afterend', button);
          }
        }

        var priceBox = element.querySelector('.t4s-cart_meta_price');
        if (!priceBox) return;
        var original = Number(item.original_line_price || item.line_price || 0);
        var finalPrice = Number(item.final_line_price || item.line_price || 0);
        var saving = Math.max(0, original - finalPrice);
        var existing = priceBox.querySelector('.hn-mini-sale-prices');
        if (saving > 0) {
          priceBox.classList.add('hn-has-sale');
          var percent = Math.round((saving / original) * 100);
          var markup = '<div class="hn-mini-sale-prices"><span class="hn-mini-current">' + money(finalPrice) + '</span><span class="hn-mini-original">' + money(original) + '</span><span class="hn-mini-badge">' + percent + '% OFF</span><span class="hn-mini-saving">You save ' + money(saving) + '</span></div>';
          if (!existing || existing.outerHTML !== markup) {
            if (existing) existing.remove();
            priceBox.insertAdjacentHTML('beforeend', markup);
          }
        } else {
          priceBox.classList.remove('hn-has-sale');
          if (existing) existing.remove();
        }
      });

      var footer = drawer.querySelector('.t4s-drawer__bottom, .t4s-drawer__footer, .t4s-mini_cart__footer') || drawer.querySelector('.t4s-cart-total')?.parentElement;
      var totalRow = drawer.querySelector('.t4s-cart-total');
      var summary = drawer.querySelector('.hn-mini-sale-summary');
      var cartSaving = Math.max(0, Number(cart.original_total_price || cart.total_price) - Number(cart.total_price));
      if (footer && totalRow && cartSaving > 0) {
        var summaryMarkup = '<div class="hn-mini-sale-summary"><div class="hn-mini-summary-row original"><span>Original subtotal</span><span>' + money(cart.original_total_price) + '</span></div><div class="hn-mini-summary-row saving"><span>You save</span><span>-' + money(cartSaving) + '</span></div><div class="hn-mini-summary-row total"><span>Sale total</span><span>' + money(cart.total_price) + '</span></div></div>';
        if (!summary || summary.outerHTML !== summaryMarkup) {
          if (summary) summary.remove();
          totalRow.insertAdjacentHTML('beforebegin', summaryMarkup);
        }
      } else if (summary) {
        summary.remove();
      }
      var totalPrice = drawer.querySelector('.t4s-cart__totalPrice');
      if (totalPrice) totalPrice.textContent = money(cart.total_price);
    }

    new MutationObserver(scheduleRefresh).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('change', scheduleRefresh, true);
    refreshMini();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHnMiniCart);
  else initHnMiniCart();
})();


/* HN_SMART_MINI_RECOMMENDATIONS_V1 */
(function () {
  var STYLE_ID = 'hn-smart-mini-recs-css';
  var MAX_RECS = 6;
  var scheduled = 0;
  var lastSignature = '';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #t4s-mini_cart .t4s-minicart-recommendations { display: none !important; }
      #t4s-mini_cart .hn-smart-recs {
        margin: 16px 16px 4px;
        padding: 0;
        border: 1px solid #dfe7e9;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 6px 22px rgba(6,58,72,.07);
        overflow: hidden;
        color: #123f4a;
      }
      #t4s-mini_cart .hn-smart-recs__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 14px 14px 11px;
        border-bottom: 1px solid #edf1f2;
      }
      #t4s-mini_cart .hn-smart-recs__eyebrow {
        margin: 0 0 2px;
        color: #ef9216;
        font-size: 10px;
        line-height: 1;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
      }
      #t4s-mini_cart .hn-smart-recs__title {
        margin: 0;
        color: #123f4a;
        font-size: 16px;
        line-height: 1.2;
        font-weight: 800;
      }
      #t4s-mini_cart .hn-smart-recs__nav {
        display: flex;
        gap: 6px;
        flex: 0 0 auto;
      }
      #t4s-mini_cart .hn-smart-recs__nav button {
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid #cad8dc;
        border-radius: 50%;
        background: #fff;
        color: #0d5668;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
        transition: .18s ease;
      }
      #t4s-mini_cart .hn-smart-recs__nav button:hover {
        border-color: #0d5668;
        background: #f3f8f9;
        transform: translateY(-1px);
      }
      #t4s-mini_cart .hn-smart-recs__track {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: minmax(164px, 48%);
        gap: 10px;
        padding: 12px 14px 14px;
        overflow-x: auto;
        overscroll-behavior-inline: contain;
        scroll-snap-type: x mandatory;
        scrollbar-width: none;
      }
      #t4s-mini_cart .hn-smart-recs__track::-webkit-scrollbar { display: none; }
      #t4s-mini_cart .hn-smart-rec {
        min-width: 0;
        overflow: hidden;
        border: 1px solid #e5ebed;
        border-radius: 11px;
        background: #fff;
        scroll-snap-align: start;
        transition: border-color .18s ease, transform .18s ease, box-shadow .18s ease;
      }
      #t4s-mini_cart .hn-smart-rec:hover {
        border-color: #b9ced3;
        transform: translateY(-2px);
        box-shadow: 0 7px 18px rgba(6,58,72,.09);
      }
      #t4s-mini_cart .hn-smart-rec__image {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 132px;
        padding: 8px;
        background: #f7f8f8;
        overflow: hidden;
      }
      #t4s-mini_cart .hn-smart-rec__image img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform .22s ease;
      }
      #t4s-mini_cart .hn-smart-rec:hover .hn-smart-rec__image img { transform: scale(1.025); }
      #t4s-mini_cart .hn-smart-rec__body { padding: 10px 10px 12px; }
      #t4s-mini_cart .hn-smart-rec__vendor {
        margin-bottom: 4px;
        color: #ef9216;
        font-size: 9px;
        line-height: 1.1;
        font-weight: 800;
        letter-spacing: .08em;
        text-transform: uppercase;
      }
      #t4s-mini_cart .hn-smart-rec__name {
        display: -webkit-box;
        min-height: 35px;
        margin: 0;
        overflow: hidden;
        color: #174c59;
        font-size: 12px;
        line-height: 1.42;
        font-weight: 700;
        text-decoration: none;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      #t4s-mini_cart .hn-smart-rec__price {
        margin-top: 7px;
        color: #d84c3d;
        font-size: 14px;
        line-height: 1.2;
        font-weight: 800;
      }
      #t4s-mini_cart .hn-smart-recs__reason {
        padding: 0 14px 13px;
        color: #71848a;
        font-size: 10px;
        line-height: 1.35;
      }
      @media (max-width: 480px) {
        #t4s-mini_cart .hn-smart-recs { margin-inline: 12px; }
        #t4s-mini_cart .hn-smart-recs__track { grid-auto-columns: minmax(155px, 66%); }
        #t4s-mini_cart .hn-smart-rec__image { height: 122px; }
      }
    `;
    document.head.appendChild(style);
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[char];
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function shorterTitle(title) {
    var parts = String(title || '').split('|').map(function (part) { return part.trim(); }).filter(Boolean);
    return parts.slice(0, 2).join(' | ') || title || 'Recommended product';
  }

  function productImage(product) {
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.images && product.images[0]) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }
    return '';
  }

  function render(drawer, products, signature) {
    var legacy = drawer.querySelector('.t4s-minicart-recommendations');
    if (!legacy || !products.length) return;
    var old = drawer.querySelector('.hn-smart-recs');
    if (old && old.dataset.signature === signature) return;

    var cards = products.map(function (product) {
      var url = product.url || ('/products/' + product.handle);
      var image = productImage(product);
      var vendor = product.vendor || product.product_type || 'Recommended';
      return '<article class="hn-smart-rec">' +
        '<a class="hn-smart-rec__image" href="' + esc(url) + '">' +
          (image ? '<img src="' + esc(image) + '&width=360" alt="' + esc(product.title) + '" loading="lazy" width="220" height="220">' : '') +
        '</a>' +
        '<div class="hn-smart-rec__body">' +
          '<div class="hn-smart-rec__vendor">' + esc(vendor) + '</div>' +
          '<a class="hn-smart-rec__name" href="' + esc(url) + '">' + esc(shorterTitle(product.title)) + '</a>' +
          '<div class="hn-smart-rec__price">From ' + money(product.price) + '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    var section = document.createElement('section');
    section.className = 'hn-smart-recs';
    section.dataset.signature = signature;
    section.setAttribute('aria-label', 'Recommended products');
    section.innerHTML =
      '<div class="hn-smart-recs__head">' +
        '<div><div class="hn-smart-recs__eyebrow">Selected for you</div><h3 class="hn-smart-recs__title">Pairs well with your cart</h3></div>' +
        '<div class="hn-smart-recs__nav"><button type="button" class="hn-smart-recs__prev" aria-label="Previous recommendations">‹</button><button type="button" class="hn-smart-recs__next" aria-label="Next recommendations">›</button></div>' +
      '</div>' +
      '<div class="hn-smart-recs__track">' + cards + '</div>' +
      '<div class="hn-smart-recs__reason">Related products selected automatically from the items in your cart.</div>';

    if (old) old.replaceWith(section);
    else legacy.insertAdjacentElement('beforebegin', section);

    var track = section.querySelector('.hn-smart-recs__track');
    section.querySelector('.hn-smart-recs__prev').addEventListener('click', function () {
      track.scrollBy({ left: -Math.max(180, track.clientWidth * .72), behavior: 'smooth' });
    });
    section.querySelector('.hn-smart-recs__next').addEventListener('click', function () {
      track.scrollBy({ left: Math.max(180, track.clientWidth * .72), behavior: 'smooth' });
    });
  }

  async function buildRecommendations() {
    scheduled = 0;
    var drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer || !drawer.querySelector('.t4s-minicart-recommendations')) return;
    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) { return response.json(); });
      var ids = Array.from(new Set((cart.items || []).map(function (item) { return item.product_id; }).filter(Boolean)));
      if (!ids.length) return;
      var signature = ids.slice().sort().join('-');
      if (signature === lastSignature && drawer.querySelector('.hn-smart-recs')) return;

      var groups = await Promise.all(ids.slice(0, 4).map(function (id) {
        return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=4&intent=related', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : { products: [] }; })
          .then(function (data) { return data.products || []; })
          .catch(function () { return []; });
      }));

      var cartIds = new Set(ids.map(String));
      var seen = new Set();
      var combined = [];
      var longest = Math.max.apply(Math, groups.map(function (group) { return group.length; }).concat([0]));
      for (var row = 0; row < longest && combined.length < MAX_RECS; row++) {
        groups.forEach(function (group) {
          var product = group[row];
          if (!product || combined.length >= MAX_RECS) return;
          var id = String(product.id);
          if (cartIds.has(id) || seen.has(id)) return;
          seen.add(id);
          combined.push(product);
        });
      }
      if (combined.length) {
        render(drawer, combined, signature);
        lastSignature = signature;
      }
    } catch (error) {
      console.warn('Mini cart recommendations:', error);
    }
  }

  function schedule() {
    clearTimeout(scheduled);
    scheduled = setTimeout(buildRecommendations, 350);
  }

  function init() {
    addStyles();
    schedule();
    var drawer = document.querySelector('#t4s-mini_cart');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('change', schedule, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


// Hide the theme subtotal only when the clearer sale summary is present.
(function () {
  var style = document.createElement('style');
  style.textContent = '#t4s-mini_cart .t4s-drawer__bottom:has(.hn-mini-sale-summary) > .t4s-cart-total{display:none!important;}';
  document.head.appendChild(style);
})();